import classNames from "classnames";
import { JSX } from "react";
import CustomButton from "rivals/components/shared/CustomButton";
import { Props } from "rivals/components/shared/Gallery/GalleryModal/GalleryCarouselButton/types";
import styles from "rivals/components/shared/Gallery/GalleryModal/GalleryModal.module.scss";
import { FilledChevron } from "rivals/public/static/icons";

export default function GalleryCarouselButton({
  isPrev,
  onClick,
  className
}: Props): JSX.Element | null {
  const label = isPrev ? "previous" : "next";
  if (!onClick) {
    return null;
  }
  return (
    <CustomButton
      ariaLabel={label}
      className={classNames(className, styles.carouselButton, {
        [styles.prevButton]: isPrev
      })}
      icon={<FilledChevron />}
      onClick={onClick}
      philter={label}
    />
  );
}
